/**
 * CheckCircleIcon Component
 *
 * Stroked circle with checkmark, used for success toast notifications.
 */

import type { SVGProps } from 'react';

interface CheckCircleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function CheckCircleIcon({ className, ...props }: CheckCircleIconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="7" cy="7" r="6.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M10.025 5.02573L5.55071 9.5L3.5 7.44929L4.02573 6.92356L5.55071 8.44482L9.49925 4.5L10.025 5.02573Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  );
}
